import { useState } from "react";
import type { KeyboardEvent } from "react";

/** Tracks whether Caps Lock is active, updated on key down and key up. */
export const useCapsLock = () => {
  const [capsLockOn, setCapsLockOn] = useState(false);

  const onKeyDown = (e: KeyboardEvent) => setCapsLockOn(e.getModifierState("CapsLock"));
  const onKeyUp = (e: KeyboardEvent) => setCapsLockOn(e.getModifierState("CapsLock"));

  return { capsLockOn, onKeyDown, onKeyUp };
};
